import React, { useState } from "react";
import moment from "moment";

const PatientAnswers = (props) => {
  const [sectionNameOpen, setSectionNameOpen] = useState("");
  const [ansOpen, setAnsOpen] = useState(-1);

  const fixAnswerReturn = (answer) => {
    if (answer.indexOf("{") > -1 && answer.indexOf("{") > -1 && JSON.parse(answer)) {
      var answers = Object.values(JSON.parse(answer));
      answer = answers.map((ans) => (
        <div>
          {ans}
          <br />
          <br />
        </div>
      ));
    }

    return answer;
  };

  return (
    <div
      className={props.onPage ? "" : "dlt_wrapper"}
      style={{
        height: props.onPage ? "unset" : props.pageHeight,
      }}
    >
      {!props.onPage && (
        <div className="approval_close tsk_info_cls patient_q_cls" onClick={() => props.openCloseAnswers()}></div>
      )}
      <div className={props.onPage ? "pat_dets_pop_to_regular" : "dash_task_info_pop"}>
        <div className="dash_task_info_title">Questionnaire Answers</div>
        {props.answersLoaded ? (
          <div className="dash_task_table">
            <div className="dash_task_single_row dash_task_sr_no_bord">
              <div className="dt_shrink dash_task_single_desc">#</div>
              <div className="dash_task_expand patient_expand dash_task_single_desc">Question Title</div>
              <div className="dash_task_reg dash_task_single_desc" title="Answer Date">Answer Date</div>
            </div>
            {props.answersInfo && props.answersInfo.length > 1 ? (
              props.answersInfo.map((answerData, ans) => (
                <div key={ans}>
                  <div onClick={() => setAnsOpen(-1)}>
                    {(props.answersInfo[ans - 1]?.questionaire_type !== answerData.questionaire_type ||
                      props.answersInfo[ans - 1]?.times_answered !== answerData.times_answered) && (
                      <div
                        onClick={() =>
                          setSectionNameOpen(
                            answerData.questionaire_type + answerData.times_answered == sectionNameOpen
                              ? ""
                              : answerData.questionaire_type + answerData.times_answered
                          )
                        }
                        className={
                          "p_dets_quest_title_click" +
                          (answerData.questionaire_type + answerData.times_answered != sectionNameOpen
                            ? " answers_open_data"
                            : " answers_closed_data")
                        }
                      >
                        <div className="dash_task_section" style={{ marginLeft: "25px" }}>
                          {answerData.questionaire_type}
                        </div>
                        <div className="dash_task_reg patient_answer_grey patient_q_info_title_date">
                          {moment(answerData.answer_date).format("L")}
                        </div>
                      </div>
                    )}
                  </div>
                  {(props.answersInfo[ans - 1]?.section_name !== answerData.section_name ||
                    props.answersInfo[ans - 1]?.times_answered !== answerData.times_answered) &&
                    sectionNameOpen == answerData.questionaire_type + answerData.times_answered && (
                      <div className={answerData.section_name ? "p_dets_quest_title_small" : ""}>
                        {answerData.section_name}
                      </div>
                    )}
                  {sectionNameOpen == answerData.questionaire_type + answerData.times_answered && (
                    <div className="dash_task_single_row patient_q_info">
                      <div className="patient_info_q">
                        <div className="dt_shrink">{answerData.question_number}</div>
                        <div className="dash_task_expand patient_expand">
                          {answerData.question_title && answerData.question_title !== "1"
                            ? answerData.question_title
                            : answerData.question_number === "8"
                            ? ""
                            : answerData.question_number === "8.1"
                            ? "Dependent Name"
                            : answerData.question_number === "8.2"
                            ? "Dependent Date of Birth"
                            : answerData.additional_question}
                        </div>
                        <div className="dash_task_reg patient_answer_grey">
                          {moment(answerData.answer_date).format("L")}
                        </div>
                      </div>
                      {answerData.question_title ===
                        "What percentage of your time at work is spent on each of these activities daily?" && (
                        <div className="dash_task_expand patient_marg">{answerData.additional_question}</div>
                      )}
                      <div
                        className={
                          "patient_info_ans" +
                          (!answerData.question_title && answerData.question_number === "8"
                            ? " patient_answer_wt_q"
                            : "")
                        }
                      >
                        <div className="dash_task_expand patient_expand patient_q_info_bold">
                          {(answerData.question_number === "10" || answerData.question_number.split(".")[0] === "10") &&
                          answerData.additional_question !== "Name"
                            ? answerData.answer
                            : !isNaN(answerData.answer) &&
                              parseInt(answerData.answer) > 0 &&
                              answerData.question_number !== "8" &&
                              answerData.question_number !== "11" &&
                              answerData.question_number !== "12" &&
                              answerData.question_number !== "13"
                            ? parseInt(answerData.answer) + " %"
                            : answerData.question_number === "8" && !isNaN(parseInt(answerData.answer))
                            ? parseInt(answerData.answer) / 10
                            : fixAnswerReturn(answerData.answer)}
                        </div>
                        {answerData.questionaire_type !== "Initial Questionnaire" && (
                          <div className="dash_task_reg">
                            <b>{answerData.questionaire_type == "Patient Assessment " ? "0" : answerData.answer_weight}</b>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="dash_task_data_empty">No data available.</div>
            )}
          </div>
        ) : (
          <div className="p_load"></div>
        )}
      </div>
    </div>
  );
};

export default PatientAnswers;
